/**
 * GA4 page-view hook for a client-side router.
 *
 * GA4's default "page_view" only fires on the initial document load, so
 * SPA navigations are invisible unless we send them manually. This hook
 * fires `page_view` whenever the pathname + search change.
 *
 * Consent is handled upstream by index.html (Consent Mode v2 default:
 * denied) and CookieBanner (updates to granted/denied on choice), so
 * calling gtag() here is always safe — if consent is denied, GA drops
 * the hit automatically.
 */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function useGAPageViews() {
  const location = useLocation();
  useEffect(() => {
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;
    window.gtag("event", "page_view", {
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location.pathname, location.search]);
}

/**
 * Called by CookieBanner when the user makes a consent choice.
 * Flips both PostHog *and* GA4 to match the user's decision.
 */
export function updateAnalyticsConsent(choice) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  const granted = choice === "accepted";
  window.gtag("consent", "update", {
    ad_storage: granted ? "granted" : "denied",
    ad_user_data: granted ? "granted" : "denied",
    ad_personalization: granted ? "granted" : "denied",
    analytics_storage: granted ? "granted" : "denied",
  });
}
